/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compliance_Cancel_AnytimeInputs */

const tr_pricing_compliance_cancel_anytime = /** @type {(inputs: Pricing_Compliance_Cancel_AnytimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aboneliğinizi her zaman tek tıkla iptal edebilirsiniz.`)
};

const en_pricing_compliance_cancel_anytime = /** @type {(inputs: Pricing_Compliance_Cancel_AnytimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can cancel your subscription anytime with a single click.`)
};

const de_pricing_compliance_cancel_anytime = /** @type {(inputs: Pricing_Compliance_Cancel_AnytimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie können Ihr Abonnement jederzeit mit einem Klick kündigen.`)
};

const ru_pricing_compliance_cancel_anytime = /** @type {(inputs: Pricing_Compliance_Cancel_AnytimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы можете отменить подписку в любое время в один клик.`)
};

/**
* | output |
* | --- |
* | "You can cancel your subscription anytime with a single click." |
*
* @param {Pricing_Compliance_Cancel_AnytimeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_compliance_cancel_anytime = /** @type {((inputs?: Pricing_Compliance_Cancel_AnytimeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compliance_Cancel_AnytimeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_compliance_cancel_anytime(inputs)
	if (locale === "de") return de_pricing_compliance_cancel_anytime(inputs)
	if (locale === "ru") return ru_pricing_compliance_cancel_anytime(inputs)
	return tr_pricing_compliance_cancel_anytime(inputs)
});